import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dialog } from '@/components/ui/Dialog';
import { Button } from '@/components/ui/Button';
import type { InsufficientCreditsDetail } from '@/api/client';

type CreditDetail = InsufficientCreditsDetail;

export function InsufficientCreditsDialog() {
    const [open, setOpen] = useState(false);
    const [detail, setDetail] = useState<CreditDetail | null>(null);

    useEffect(() => {
        function handleInsufficientCredits(e: CustomEvent<CreditDetail | null>) {
            setDetail(e.detail);
            setOpen(true);
        }

        window.addEventListener('credits:insufficient', handleInsufficientCredits as EventListener);
        return () => window.removeEventListener('credits:insufficient', handleInsufficientCredits as EventListener);
    }, []);

    function handleClose() {
        setOpen(false);
    }

    return (
        <Dialog open={open} onClose={handleClose} title="Insufficient Credits" afterLeave={() => setDetail(null)}>
            <p className="text-sm text-gray-600 dark:text-gray-400">
                {detail ? (
                    <>
                        You need <span className="font-semibold text-gray-900 dark:text-white">{detail.creditsNeeded} more credits</span> to
                        complete this action. You currently have <span className="font-semibold text-gray-900 dark:text-white">{detail.creditsAvailable} credits</span>.
                    </>
                ) : (
                    "You don't have enough credits to complete this action."
                )}
            </p>
            <div className="mt-5 flex justify-end gap-3">
                <Button variant="ghost" size="sm" onClick={handleClose}>
                    Dismiss
                </Button>
                {/* A link styled as the primary sm Button: a <button> inside an <a> is invalid. */}
                <Link
                    to="/credits"
                    onClick={handleClose}
                    className="inline-flex items-center justify-center rounded-md font-medium transition-all focus:outline-hidden focus:ring-2 focus:ring-offset-2 shadow-xs bg-accent text-white hover:bg-accent-hover focus:ring-accent px-3 py-1.5 text-sm"
                >
                    Buy Credits
                </Link>
            </div>
        </Dialog>
    );
}
